import { useMemo } from 'react'

import _ from 'lodash'

import {
  formatRewardRequestPartnerMeta,
  resolveRewardRequestPartnerMeta
} from '@/features/store/lib/resolveRewardRequestMeta'
import { useGamificationDataStore } from '@/shared/store/gamificationDataStore'

export const DigitalProductStoreBottomSheetRewardRequestItemLabel = ({
  quantity,
  rewardItem
}) => {
  const partners = useGamificationDataStore(
    state => state.getActiveProductData().partners
  )

  const partnerNameById = useMemo(
    () =>
      Object.fromEntries(
        partners.map(partner => [String(partner.id), partner.name])
      ),
    [partners]
  )

  const metaLine = formatRewardRequestPartnerMeta(
    resolveRewardRequestPartnerMeta(rewardItem, partnerNameById)
  )

  // A foto do brinde resgatado, com a do item base como segunda fonte —
  // variação nem sempre tem imagem própria. Mesmo encadeamento da vitrine.
  const imageUrl =
    _.get(rewardItem, 'image.file.url') ||
    _.get(rewardItem, 'reward.image.file.url') ||
    '/placeholders/reward.jpg'

  return (
    <div className="min-w-0 flex-1">
      {/* Acima do título e alinhada à esquerda: o histórico é uma lista densa,
          e a foto puxa o reconhecimento antes da leitura. */}
      <img
        src={imageUrl}
        alt=""
        aria-hidden
        className="mb-1.5 size-10 rounded-lg object-cover"
      />
      <span className="block text-sm font-bold">
        {quantity}x {rewardItem?.name}
      </span>
      {metaLine ? (
        <span className="mt-0.5 block text-2xs font-semibold leading-snug text-gray-700 line-clamp-2">
          {metaLine}
        </span>
      ) : null}
    </div>
  )
}
